import React, { useState, useMemo } from 'react';
import { useTaskLibrary } from '../../hooks/queries/useTaskLibrary';

interface TaskPickerProps {
  onSelect: (task: { label: string; icon: string; color: string; start?: string; end?: string }) => void;
  onClose: () => void;
}

export function TaskPicker({ onSelect, onClose }: TaskPickerProps) {
  const { libraryTasks, loading } = useTaskLibrary();
  const [searchTerm, setSearchTerm] = useState('');

  const filteredTasks = useMemo(() => {
    return libraryTasks.filter(t => 
      t.label.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [libraryTasks, searchTerm]);

  return (
    <div 
      onClick={(e) => {
        e.stopPropagation();
        onClose();
      }}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1100,
        backdropFilter: 'blur(4px)'
      }}>
      <div 
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: 'white',
          padding: '24px',
          borderRadius: '16px',
          width: '90%',
          maxWidth: '800px',
          height: '80vh',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '0 10px 25px rgba(0,0,0,0.2)'
        }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '16px', alignItems: 'center' }}>
          <h3 style={{ margin: 0 }}>Task Library</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#1F1F22' }}>✕</button>
        </div>

        <div style={{ display: 'flex', gap: '12px', marginBottom: '16px', flexWrap: 'wrap' }}>
             <input
                type="text"
                placeholder="Search tasks..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                    padding: '8px 12px',
                    borderRadius: '8px',
                    border: '1px solid #e2e8f0',
                    flex: 1,
                    minWidth: '200px'
                }}
             />

        </div>

        {loading ? (
          <div style={{ padding: '20px', textAlign: 'center', color: '#1F1F22' }}>Loading...</div>
        ) : filteredTasks.length === 0 ? (
          <div style={{ padding: '20px', textAlign: 'center', color: '#1F1F22', fontStyle: 'italic' }}>
              No tasks found matching your search.
          </div>
        ) : (
          <div style={{ flex: 1, overflowY: 'auto', display: 'flex', flexDirection: 'column', position: 'relative' }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {filteredTasks.map((t) => {
                    return (
                        <button
                            key={`${t.source}-${t.label}`}
                            onClick={() => onSelect({
                                label: t.label,
                                icon: t.icon ?? '📝',
                                color: t.color ?? '#64748b',
                                start: undefined, 
                                end: undefined
                            })}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px',
                                padding: '12px',
                                background: 'white',
                                border: '1px solid #e2e8f0',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                textAlign: 'left',
                                transition: 'background 0.2s',
                                borderLeft: `4px solid ${t.color}`
                            }}
                            onMouseOver={(e) => e.currentTarget.style.background = '#f7fafc'}
                            onMouseOut={(e) => e.currentTarget.style.background = 'white'}
                        >
                            <span style={{ fontSize: '24px' }}>{t.icon}</span>
                            <div style={{ flex: 1 }}>
                                <div style={{ fontWeight: 600, color: '#2d3748' }}>{t.label}</div>
                                <div style={{ fontSize: '12px', color: '#1F1F22' }}>
                                    <span style={{ 
                                        marginRight: '8px', 
                                        fontWeight: 500, 
                                        color: t.source === 'system' ? '#3182CE' : '#805AD5',
                                        background: t.source === 'system' ? '#EBF8FF' : '#F3E8FF',
                                        padding: '2px 6px',
                                        borderRadius: '4px'
                                    }}>
                                        {t.source === 'system' ? 'System' : 'History'}
                                    </span>
                                    {t.defaultDurationMinutes} min
                                </div>
                            </div>
                            <span style={{ fontSize: '20px', color: '#cbd5e0' }}>+</span>
                        </button>
                    );
                })}
              </div>
          </div>
        )}
      </div>
    </div>
  );
}
